import { Layout, Space, Tabs, Spin, message, Upload, Button, Badge } from 'antd';
import React, { useEffect, useState } from 'react';
import UpdateEmployeeInfo from './UpdateEmployeeInfo';
import UpdateEmploymentInfo from './UpdateEmploymentInfo';
import UpdateUserInfo from './UpdateUserInfo';
import { downloadEmpCardReq, downloadReportReq, getEmploymentHistoryReq, getProfileCardByEmploymentIdReq, uploadPhotoReq } from '../requests';
import { makeRequestStateless, handleDownloadFile, makeRequest } from "@utils/helpers";
import IndexContacts from '@mods/employeeManagement/contacts/IndexContacts';
import UpdatePayrollPolicy from './UpdatePayrollPolicy';
import { ModalComponent } from "@comps/components"
//import IndexAssets from '../../assets/IndexAssets';
import IndexRelatives from '../../relatives/IndexRelatives';
import IndexExperience from '../../experiences/IndexExperience';
import IndexAddresses from '../../addresses/IndexAddresses';
import IndexEducations from '../../educations/IndexEducations';
import IndexBanks from '../../bank/IndexBanks';
import IndexCompanyTimeSheet from '../../../attendanceManagement/companyTimeSheet/IndexCompanyTimeSheet';
import IndexCompanyRoaster from '../../../rosterManagement/companyRoster/IndexCompanyRoaster';
import IndexCompanyLeaveRequests from '../../../leaveManagement/leave/companyLeaves/IndexCompanyLeaveRequests';
import IndexMyPayslip from '../../../payrollManagement/myPayslips/IndexMyPayslip';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import IndexCompanyLends from '../../../lendManagement/lends/companyLends/IndexCompanyLends';
import { useSelector } from 'react-redux';
import EmployeePoliciesTab from './EmployeePoliciesTab';

const { Content } = Layout;

const ViewEmployee = (props) => {

  //console.log(props);
  //------------use states start----------------
  const [defaultProfileCard, setDefaultProfileCard] = useState();
  const [loading, setLoading] = useState(true)
  const [content, setContent] = useState(null)
  const employeeId = props.employee_id
  const [loader, setLoader] = useState(false);
  const [employmentHistoryLoader, setEmploymentHistoryLoader] = useState(false);
  const [employmentHistoryVisible, setEmploymentHistoryVisible] = useState(false);
  const [employmentHistory, setEmploymentHistory] = useState([]);
  const authUser = useSelector((state) => state.auth.authUser);
  //-----------end use states--------------------
  useEffect(() => {
    getProfileCardByEmploymentId(props.employment_id);
    // eslint-disable-next-line
  }, [props]);

  const getProfileCardByEmploymentId = (id) => {
    makeRequestStateless(getProfileCardByEmploymentIdReq, { id, showActive: props.showActive }, getProfileCardByEmploymentIdSuccess, null)
    setLoading(true)
    setContent(null)
  }
  const getProfileCardByEmploymentIdSuccess = (response) => {
    setFileList(response.profile_card.profile_pic_url === "images/arnold-avatar.jpg" ? [] : [{
      uid: '-1',
      status: 'done',
      url: response.profile_card.profile_pic_url
    }])
    setDefaultProfileCard(response.profile_card)
    setData()
    setLoading(false)
  }
  const TabContentStyle = { background: 'white' }
  const setData = () => {

    setContent(
      <Content style={ TabContentStyle } >
        <style>
          { `
            /* Remove standard Ant Design bottom border and animated ink-bar */
            .multi-line-tabs .ant-tabs-nav::before {
              display: none !important;
            }
            .multi-line-tabs .ant-tabs-ink-bar {
              display: none !important;
            }

            /* Tab Top Navigation Wrapping */
            .multi-line-tabs .ant-tabs-nav {
              height: auto !important;
              margin-bottom: 24px !important;
            }
            .multi-line-tabs .ant-tabs-nav-wrap {
              overflow: visible !important;
              display: flex !important;
              flex-wrap: wrap !important;
            }
            
            /* Tab items container flex gap layout */
            .multi-line-tabs .ant-tabs-nav-list {
              flex-wrap: wrap !important;
              width: 100%;
              gap: 10px;
              padding: 4px;
              transform: none !important; /* Disables JS native scrolling shift */
              justify-content: flex-start !important;
            }

            /* Tab Item Native Style (Pill Style) */
            .multi-line-tabs .ant-tabs-tab {
              margin: 0 !important;
              padding: 8px 20px !important;
              border-radius: 30px !important;
              background-color: #F8FAFC !important;
              border: 1px solid #E2E8F0 !important;
              transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
              box-shadow: 0 1px 2px rgba(0,0,0,0.02) !important;
            }
            
            .multi-line-tabs .ant-tabs-tab:hover {
              background-color: #EEF2FF !important;
              border-color: #4079FC !important;
              transform: translateY(-1px);
            }

            /* Active Selected Tab Pill */
            .multi-line-tabs .ant-tabs-tab.ant-tabs-tab-active {
              background-color: #4079FC !important;
              border-color: #4079FC !important;
              box-shadow: 0 4px 10px rgba(64, 121, 252, 0.2) !important;
              transform: translateY(0) !important;
            }
            
            .multi-line-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
              color: white !important;
              font-weight: 500 !important;
              text-shadow: 0 0 1px rgba(255,255,255,0.4) !important;
            }

            /* Native text color fix */
            .multi-line-tabs .ant-tabs-tab .ant-tabs-tab-btn {
              color: #4A5568 !important;
              font-size: 14.5px !important;
              font-weight: 500 !important;
              transition: color 0.2s !important;
            }

            /* Hide Operations native ellipsis menu */
            .multi-line-tabs .ant-tabs-nav-operations {
              display: none !important;
            }
          `}
        </style>
        <Tabs
          className="multi-line-tabs"
          tabPosition='top'
          animated={ true }
          closable={ true }
        >
          <Tabs.TabPane tab="Employee" key={ 'employeeinfo' }>
            <UpdateEmployeeInfo id={ employeeId } setDefaultProfileCard={ setDefaultProfileCard } />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Employment" key={ 'employmentinfo' }>
            <UpdateEmploymentInfo id={ props.employment_id } setDefaultProfileCard={ setDefaultProfileCard } showActive={ props.showActive } />
          </Tabs.TabPane>
          <Tabs.TabPane tab="User" key={ 'user' }>
            <UpdateUserInfo id={ employeeId } disabled={ false } setDefaultProfileCard={ setDefaultProfileCard } />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Address" key={ 'address' } >
            <IndexAddresses filters={ `employments_|${employeeId}` } employee_id={ employeeId } modkey="employeeAddress" />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Relatives" key={ 'relatives' }>
            <IndexRelatives filters={ `employments_|${employeeId}` } modkey="employeeAddress" />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Contacts" key={ 'contact' }>
            <IndexContacts filters={ `employments_|${props.employee_id}` } modkey="employeeContact" />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Education" key={ 'education' }>
            <IndexEducations filters={ `employments_|${employeeId}` } modkey="employeeEducation" />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Experience" key={ 'qualification&experiences' }>
            <IndexExperience filters={ `employments_|${employeeId}` } modkey="employeeExperience" />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Shifts" key={ 'shifts' }>
            <IndexCompanyRoaster module='myRoaster' filters={ `employee_|${props.employment_id}` } modkey="myRoster" />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Attendance" key={ 'attendance' }>
            <IndexCompanyTimeSheet filters={ `employee_|${props.employment_id}` } module="my-attendance" modkey="myAttendance" />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Leaves" key={ 'leaves' }>
            <IndexCompanyLeaveRequests module='myLeaveRequest' filters={ `employee_|${props.employment_id};employees_|${props.employment_id}` } modkey="leaveRequest" employment_id={ props.employment_id } />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Bank" key={ 'bank' }>
            <IndexBanks filters={ `employments_|${employeeId}` } modkey="employeeBank" />
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab="Policy" key={ 'policy' }>
            <EmployeePoliciesTab employmentId={ props.employment_id } />
          </Tabs.TabPane> */}
          <Tabs.TabPane tab="Salary" key={ 'payroll' }>
            <UpdatePayrollPolicy id={ props.employment_id } employeeId={ employeeId } disabled={ false } />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Payslip" key={ 'payslip' }>
            <IndexMyPayslip modkey="myPayslips" employment_id={ props.employment_id } />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Loan & Advances" key={ 'loans' }>
            <IndexCompanyLends user={ authUser } filters={ `employee_|${props.employment_id}` } module="my-requests" modkey="lends" />
          </Tabs.TabPane>
          {/* <Tabs.TabPane tab="Asset" key={ 'assetsdetails' } >
            <IndexAssets filters={ `employments_|${props.employment_id}` } />
          </Tabs.TabPane>  */}
        </Tabs>
      </Content>
    )
  }

  //-----------styling------------

  const [fileList, setFileList] = useState([])

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });


  const onChange = ({ fileList: newFileList }) => {

    // Update the status of the uploaded file based on the response from your backend
    setFileList(newFileList.map(file => {
      if (file.response) {
        // Check if your backend returned a success response
        if (file.response.status === 'success') {
          message.info('Updated Successfully')
          return { ...file, status: 'done' };
        } else {
          // If your backend returned an error response
          message.error(`File upload failed: ${file.response.message}`);
          return { ...file, status: 'error' };
        }
      }
      return file;
    }));
  };

  const beforeUpload = (file) => {
    // Perform any validation or checks before uploading
    return true;
  };

  const uploadPhoto = async ({ file, onSuccess, onError }) => {
    const payload = {
      file: file,
      employeeId: employeeId
    }
    await makeRequestStateless(uploadPhotoReq, payload, () => {
      onSuccess()
      onUpdatedPhoto()
    }, onUpdatedPhoto);
  }
  const removePhoto = async ({ file }) => {
    const payload = {
      file: '',
      employeeId: employeeId
    }
    await makeRequestStateless(uploadPhotoReq, payload, onUpdatedPhoto, onUpdatedPhoto);
  }
  const onUpdatedPhoto = (data, res) => {
    props.onCompleted()
    message.info('Updated Successfully')
  }
  const onPreview = async (file) => {

    if ((file.url !== undefined) && (file.extension === 'pdf' || file.type === 'application/pdf')) {
      // Open the PDF file in a new tab
      window.open(file.url, '_blank');
    }
    else {
      if (file.type !== 'application/pdf') {
        // Handle preview for other file types (e.g., images)
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
      }
    }
  };

  //download card
  const downloadEmpCard = (record) => {
    const payload = {
      filters: `download_type_|pdf;ids_|${props.employment_id}`,
    }

    makeRequest(setLoader, downloadEmpCardReq, payload, onDownloadSuccess, onDownloadSuccess);

    //setLoader(true)
  }

  const onDownloadSuccess = (err, res) => {
    // setLoader(false)
    if (res.code === undefined) {
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `employee-card.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
    setLoader(false)
  }


  const downloadReport = (format) => {
    message.info('Downloading...  wait a few seconds.')
    let filters = `employee_|${props.employment_id};`
    const payload = {
      page: 1,
      filters: `${filters}report_id_|${'class_name'},user|${props.employment_id};format_|${format};class_name_|App\\Exports\\EmployeeEmployment\\EmploymentInfoReportExport`,
      employment_id: props.employment_id,
      format: format,
      class_name: 'App\\Exports\\EmployeeEmployment\\EmploymentInfoReportExport'
    }
    //setChildComponent(null)
    makeRequest(setLoader, downloadReportReq, payload, onDownloadReportSuccess, onDownloadReportSuccess);

  }

  const downloadFullEmploymentExitReport = () => {
    message.info('Downloading full employment & exit report... wait a few seconds.')
    const joiningDate = dayjs(defaultProfileCard?.joining_date);
    const from = joiningDate.isValid()
      ? joiningDate.format('YYYY-MM-DD')
      : dayjs().startOf('year').format('YYYY-MM-DD');
    const to = dayjs().format('YYYY-MM-DD');
    const filters = `employee_|${props.employment_id};from_|${from};to_|${to};`;
    const payload = {
      page: 1,
      filters: `${filters}report_id_|class_name,user|${props.employment_id};format_|xlsx;class_name_|App\\Exports\\EmployeeEmployment\\EmployeeFullEmploymentExitReportExport`,
      employment_id: props.employment_id,
      format: 'xlsx',
      class_name: 'App\\Exports\\EmployeeEmployment\\EmployeeFullEmploymentExitReportExport'
    }
    makeRequest(setLoader, downloadReportReq, payload, onDownloadFullEmploymentExitReportSuccess, onDownloadFullEmploymentExitReportSuccess);
  }

  const onDownloadReportSuccess = (err, res) => {
    setLoader(false)
    if (res.code === undefined) {
      // Extract file extension
      const fileExtension = res.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'pdf'
      const fileName = `Employee_Information_${dayjs().format('YYYY-MM-DD')}.${fileExtension}`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }

  const onDownloadFullEmploymentExitReportSuccess = (err, res) => {
    setLoader(false)
    if (res.code === undefined) {
      const fileName = `Employee_Full_Employment_Exit_Report_${dayjs().format('YYYY-MM-DD')}.xlsx`
      handleDownloadFile(fileName, res)
    }
    else {
      message.error(res.message)
    }
  }

  const openEmploymentHistory = () => {
    makeRequest(setEmploymentHistoryLoader, getEmploymentHistoryReq, employeeId, onEmploymentHistorySuccess, onEmploymentHistoryError);
  }

  const onEmploymentHistorySuccess = (response) => {
    setEmploymentHistory(response.employment_history || []);
    setEmploymentHistoryVisible(true);
  }

  const onEmploymentHistoryError = (error, response) => {
    message.error(response?.response?.data?.message || 'Unable to fetch employment history.');
  }

  const formatHistoryDate = (date) => {
    return date ? dayjs(date).format('DD-MMM-YYYY') : '-';
  }
  //----------end styling-----------
  return (
    <>
      <Space
        style={ {
          marginBottom: 24,
        } }
      >
      </Space>
      <Spin spinning={ loading }>
        <div style={ { marginTop: -50 } } >
          <Upload
            className=''
            customRequest={ uploadPhoto }
            listType="picture-circle"
            fileList={ fileList }
            accept=".jpg,.jpeg,.png"
            onChange={ onChange }
            onPreview={ onPreview }
            beforeUpload={ beforeUpload }
            onRemove={ removePhoto }
            multiple={ false }
          >
            { fileList.length === 1 ? null : <span>Upload</span> }
          </Upload>


        </div>

        {/* <div style={ { marginTop: -60 } } >
          <img src={ defaultProfileCard ? defaultProfileCard.profile_pic_url : '' } height='95px' style={ { borderRadius: '60px', width: 95, position: "relative", top: 20 } } alt='' />
        </div> */}
        <div style={ { marginTop: -90 } }>

          <span className='offical-email'>{ defaultProfileCard ? defaultProfileCard.official_email : '' }</span>
          <p className='full-name'>{ defaultProfileCard ? defaultProfileCard.full_name : '' }</p>

          <span className='designation-name'>{ defaultProfileCard ? defaultProfileCard.designation_name : '' }</span>
          <p className='mobile-no'>{ defaultProfileCard ? defaultProfileCard.mobile_no : '' }</p>
          <img src={ require("@assets/images/Line 19.png") } alt="Employee" style={ { position: 'relative', left: 115, top: -10 } } />
          <p><span className="age">Joining Date:</span><span className="age-name" >{ defaultProfileCard ? defaultProfileCard.joining_date : '' }</span></p>
          <p><span className="age">Age:</span><span className="age-name" >{ defaultProfileCard ? defaultProfileCard.age : '' }</span></p>

          <p><span className="profile">Profile Score:</span><span className="profile-score">{ defaultProfileCard ? defaultProfileCard.profile_score + ' %' : '' }</span></p>
          <p className='code'><span className="codes ps-5">Code:</span><span className="code-id">{ defaultProfileCard ? defaultProfileCard.code : '' }</span></p>

        </div>
        <div style={ { display: 'flex', gap: '10px' } }>
          <Button type='primary' style={ { borderRadius: '5px' } } className='download-card mb-5' onClick={ openEmploymentHistory } loading={ employmentHistoryLoader }>
            History
          </Button>
          <Button type='primary' style={ { borderRadius: '5px' } } disabled={ loader } className='download-card mb-5' onClick={ () => downloadEmpCard() } >
            Download Card
          </Button>
          <Button icon={ <FileExcelOutlined className='text-success' /> } style={ { borderRadius: '5px' } } disabled={ loader } className='download-card mb-5' onClick={ () => downloadReport('xlsx') } >
            Employee Information
          </Button>
          <Button icon={ <FilePdfOutlined className='text-danger' /> } style={ { borderRadius: '5px' } } disabled={ loader } className='download-card mb-5' onClick={ () => downloadReport('pdf') } >
            Employee Information
          </Button>
          <Button icon={ <FileExcelOutlined className='text-success' /> } style={ { borderRadius: '5px' } } disabled={ loader } className='download-card mb-5' onClick={ downloadFullEmploymentExitReport } >
            Full Employment Report
          </Button>
        </div>
      </Spin>


      <Layout style={ { marginTop: -20 } }>

        <Layout hasSider>
          { content }
        </Layout>
      </Layout>

      <ModalComponent width={ 1000 } open={ previewOpen } title={ defaultProfileCard ? defaultProfileCard.full_name : '' } footer={ null } onCancel={ handleCancel }>
        <div style={ {
          textAlign: 'center',
          padding: 100,
          paddingTop: 0
        } }>
          <img
            alt=""
            style={ {
              width: '50%',
            } }
            src={ previewImage }
          />
        </div>
      </ModalComponent>

      <ModalComponent
        width={ 900 }
        open={ employmentHistoryVisible }
        title="Employment History"
        footer={ null }
        onCancel={ () => setEmploymentHistoryVisible(false) }
      >
        <Spin spinning={ employmentHistoryLoader }>
          { employmentHistory.length === 0 ? (
            <div>No employment history found.</div>
          ) : (
            <div style={ { display: 'grid', gap: 16 } }>
              { employmentHistory.map((history, index) => (
                <div
                  key={ history.id || index }
                  style={ {
                    border: '1px solid #E5E7EB',
                    borderRadius: 10,
                    padding: 16,
                    background: '#FAFBFC'
                  } }
                >
                  <div style={ { display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' } }>
                    <strong>{ history.tenure_label || `Employment Tenure ${index + 1}:` } { history.is_active ? <Badge count='Current' color='green' /> : '' }</strong>
                    <span>{ history.tenure_identifier || '-' }</span>
                  </div>
                  <div style={ { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12, marginTop: 12 } }>
                    <div><strong>Joining Date:</strong> { formatHistoryDate(history.joining_date) }</div>
                    <div><strong>Leaving Date:</strong> { formatHistoryDate(history.end_of_employment?.last_working_date || history.end_of_employment?.resignation_date) }</div>
                    <div><strong>Department:</strong> { history.department?.name || '-' }</div>
                    <div><strong>Designation:</strong> { history.designation?.name || '-' }</div>
                    <div><strong>Branch:</strong> { history.branch?.name || '-' }</div>
                    <div><strong>Location:</strong> { history.location?.name || '-' }</div>
                    <div><strong>Employee Type:</strong> { history.employee_type?.name || '-' }</div>
                    <div><strong>Contract Type:</strong> { history.contracttype?.name || '-' }</div>
                    <div><strong>Status:</strong> { history.is_active ? <Badge count="Active" color='green'></Badge> : <Badge count="Inactive"></Badge> }</div>
                    <div><strong>Reason:</strong> { history.end_of_employment?.reason?.name || '-' }</div>
                  </div>
                </div>
              )) }
            </div>
          ) }
        </Spin>
      </ModalComponent>
    </>
  );

};
export default ViewEmployee;
